import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import HotMovies from './components/HotMovies';
import NewMovies from './components/NewMovies';
import Features from './components/Features';
import { Helmet } from './components/SEO';
import SchemaOrg, { organizationSchema, webSiteSchema, getWebPageSchema } from '@/components/feature/SchemaOrg';

export default function Home() {
  return (
    <>
      <Helmet
        title="被窝网电影大全 - 高清免费在线观看不缓冲"
        description="被窝网电影大全为您提供海量免费高清电影在线观看，聚合热门电影电视剧资源，最新全集不卡顿流畅播放，尽享舒适观影。被窝网电影大全,被窝网电影高清,被窝网电影免费,电影大全,免费电影在线,高清电影,不缓冲,电视剧全集"
        keywords="被窝网电影大全,被窝网电影高清,被窝网电影免费,电影大全,免费电影在线,高清电影,不缓冲,电视剧全集,被窝网,影视资源"
        canonicalUrl="/"
        ogType="website"
      />
      <SchemaOrg schema={organizationSchema} />
      <SchemaOrg schema={webSiteSchema} />
      <SchemaOrg schema={getWebPageSchema(
        '被窝网电影大全 - 高清免费在线观看不缓冲',
        '被窝网电影大全为您提供海量免费高清电影在线观看，聚合热门电影电视剧资源，最新全集不卡顿流畅播放，尽享舒适观影。',
        '/'
      )} />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <CategoryNav />
          <HotMovies />
          <NewMovies />
          <Features />
        </main>
        <Footer />
      </div>
    </>
  );
}